// Dependencies
import React from 'react';

// import { EVENT_TYPE, FORM_NAME } from '../../../../../lib/analytics-constants';
import { RentVsBuyInput } from '../../../../../lib/utils';
import { LEGACY_FIELD_NAMES } from '../../../analytics-constants';
import PropertyTaxRateInput from '../property-tax-rate';

const CONTROL_PANEL = 'controlPanel';

const analyticsPayload = {
  enabled: true,
  payload: {
    legacy: {
      formName: CONTROL_PANEL,
      fieldName: LEGACY_FIELD_NAMES.PROPERTY_TAX_RATE,
    },
    // bedrock: {
    //   eventType: EVENT_TYPE.MORTGAGE_PROPERTY_TAX_UPDATED,
    //   form_name: FORM_NAME.RENT_VS_BUY_CALCULATOR,
    //   was_prefilled: true,
    //   page_number: null,
    //   total_pages: null,
    // },
  },
};
const PropertyTaxRateInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <PropertyTaxRateInput
      label={label}
      tooltip={tooltip}
      analytics={analyticsPayload}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default PropertyTaxRateInputWithAnalytics;
